import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export const JoinPage = () => {
  const navigate = useNavigate();
  const { slug } = useParams();
  const associationSlug = slug || "kandzile"; // Fallback if accessed directly (shouldn't happen with new routing but safe)
  const [membershipType] = useState("adhesion");
  const [country] = useState("FR");
  const [year] = useState(new Date().getFullYear());

  const handleNewMember = () => {
    navigate(`/portal/${associationSlug}/inscription`, {
      state: { membershipType, country, year },
    });
  };

  const handleExistingMember = () => {
    navigate(`/portal/${associationSlug}/paiement`, {
      state: { membershipType, country, year },
    });
  };

  return (
    <div className="max-w-3xl mx-auto py-12 px-4">
      <Card className="bg-white/90" data-testid="join-card">
        <CardHeader>
          <CardTitle className="text-xl" data-testid="join-title">
            Adhésion Hafani Kandzilé
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-2" data-testid="join-single-plan-info">
            <Label className="text-sm font-medium">Type d&apos;adhésion</Label>
            <p className="text-sm text-[#5c6b64]">
              Une adhésion annuelle unique au fonds Hafani Kandzilé, pour participer à la solidarité
              active et à la protection de la communauté.
            </p>
          </div>

          <div className="grid gap-3 md:grid-cols-2" data-testid="join-actions">
            <Button
              className="bg-[#1FE8B6] text-[#0E1B16] hover:bg-[#18c99c] rounded-full px-4"
              onClick={handleNewMember}
              data-testid="join-new-member-button"
            >
              Je suis nouveau membre
            </Button>
            <Button
              variant="outline"
              className="rounded-full px-4"
              onClick={handleExistingMember}
              data-testid="join-existing-member-button"
            >
              Je suis déjà membre (payer ma cotisation)
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
